webpackJsonp([110827513013377],{

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ Version 1.3.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	function namespace(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	}
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	function creator(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	}
	
	function none() {}
	
	function selector(selector) {
	  return selector == null ? none : function() {
	    return this.querySelector(selector);
	  };
	}
	
	function selection_select(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function empty() {
	  return [];
	}
	
	function selectorAll(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	}
	
	function selection_selectAll(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	}
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	function selection_filter(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function sparse(update) {
	  return new Array(update.length);
	}
	
	function selection_enter() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	}
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	function selection_data(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	}
	
	function selection_exit() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	}
	
	function selection_merge(selection$$1) {
	
	  for (var groups0 = this._groups, groups1 = selection$$1._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	}
	
	function selection_order() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	}
	
	function selection_sort(compare) {
	  if (!compare) compare = ascending;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	}
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function selection_call() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	}
	
	function selection_nodes() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	}
	
	function selection_node() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	}
	
	function selection_size() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	}
	
	function selection_empty() {
	  return !this.node();
	}
	
	function selection_each(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	}
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	function selection_attr(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	}
	
	function defaultView(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	}
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	function selection_style(name, value, priority) {
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : styleValue(this.node(), name);
	}
	
	function styleValue(node, name) {
	  return node.style.getPropertyValue(name)
	      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
	}
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	function selection_property(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	}
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	function selection_classed(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	}
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	function selection_text(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	}
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	function selection_html(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	}
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	function selection_raise() {
	  return this.each(raise);
	}
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	function selection_lower() {
	  return this.each(lower);
	}
	
	function selection_append(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	}
	
	function constantNull() {
	  return null;
	}
	
	function selection_insert(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	}
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	function selection_remove() {
	  return this.each(remove);
	}
	
	function selection_cloneShallow() {
	  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
	}
	
	function selection_cloneDeep() {
	  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
	}
	
	function selection_clone(deep) {
	  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
	}
	
	function selection_datum(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	}
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	function selection_on(typename, value, capture) {
	  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	}
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	function dispatchEvent(node, type, params) {
	  var window = defaultView(node),
	      event = window.CustomEvent;
	
	  if (typeof event === "function") {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	function selection_dispatch(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	}
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  clone: selection_clone,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	function select(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	}
	
	function create(name) {
	  return select(creator(name).call(document.documentElement));
	}
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	function sourceEvent() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	}
	
	function point(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	}
	
	function mouse(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point(node, event);
	}
	
	function selectAll(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	}
	
	function touch(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point(node, touch);
	    }
	  }
	
	  return null;
	}
	
	function touches(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point(node, touches[i]);
	  }
	
	  return points;
	}
	
	exports.create = create;
	exports.creator = creator;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.clientPoint = point;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.style = styleValue;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = defaultView;
	exports.customEvent = customEvent;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Selection = __webpack_require__(289);
	
	__webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldOfViewDiagram = function (_React$Component) {
	  _inherits(FieldOfViewDiagram, _React$Component);
	
	  function FieldOfViewDiagram(props) {
	    _classCallCheck(this, FieldOfViewDiagram);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      heightUpPost: props.heightUpPost || 3,
	      laneWidth: props.laneWidth || 3,
	      numLanes: props.numLanes || 2,
	      pavWidth: props.pavWidth || 1,
	      pavHeight: props.pavHeight || 0.12,
	      mountAngle: props.mountAngle || 38,
	      fovAngle: props.fovAngle || 16
	    };
	
	    _this.svg;
	    _this.postRect;
	    _this.pavRect;
	    _this.viewTri;
	    return _this;
	  }
	
	  FieldOfViewDiagram.prototype.componentDidMount = function componentDidMount() {
	    this.initDiagram();
	    this.fullUpdate(this.state);
	  };
	
	  FieldOfViewDiagram.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // console.log('New props');
	    // console.log(nextProps);
	    // TODO: Only update the parts of the diagram that I need to rather than the whole thing?
	    // TODO: Also check if the new props are even different to the current values (see: https://reactjs.org/blog/2016/01/08/A-implies-B-does-not-imply-B-implies-A.html).
	    // TODO: There may be a better practise for applying these updates. In later versions of react the getDerivedStateFromProps method seems to be the better way of doing it.
	    this.setState(nextProps, function () {
	      _this2.fullUpdate(_this2.state);
	    });
	  };
	
	  FieldOfViewDiagram.prototype.initDiagram = function initDiagram() {
	
	    var node = this.node;
	    this.svg = (0, _d3Selection.select)(node);
	
	    // Lamppost
	    this.postRect = this.svg.append('rect');
	
	    // Pavement
	    this.pavRect = this.svg.append('rect').style('fill', 'grey');
	
	    // Field of view triangle
	    this.viewTri = this.svg.append('polygon').style('fill', '#00BFF3') // remove any fill colour
	    .style('opacity', 0.5);
	  };
	
	  FieldOfViewDiagram.prototype.fullUpdate = function fullUpdate(sizes) {
	
	    // What is the width and height of the svg element so we can adjust sizes accordingly
	    var svgWidth = this.convertD3dimension(this.svg.style('width'));
	    var svgHeight = this.convertD3dimension(this.svg.style('height'));
	    // console.log(`SVG width is ${svgWidth}, height is ${svgHeight}`);
	
	    // How many metres across will everything total up to
	    var postWidth = 0.15; // in metres
	    var metresAcross = postWidth + sizes.pavWidth + sizes.laneWidth * sizes.numLanes;
	    // ... and how many metres tall
	    var minPostHeight = 5;
	    var postHeight = sizes.heightUpPost > minPostHeight ? sizes.heightUpPost + 1 : minPostHeight;
	    var metresTall = postHeight + sizes.pavHeight;
	
	    // Calculate the scaling we should use so that it'll all fit in.
	    var xScaling = svgWidth / metresAcross;
	    var yScaling = svgHeight / metresTall;
	    var s = xScaling > yScaling ? yScaling : xScaling;
	    // console.log('Scaling is:' + s);
	
	    // Calculate the width of the pavement plus the width of the lamppost (in metres)
	    var pavPlusPostWidth = sizes.pavWidth + postWidth;
	
	    // Update the post
	    this.postRect.attr('width', postWidth * s).attr('height', postHeight * s).attr('y', svgHeight - (sizes.pavHeight + postHeight) * s);
	
	    // Update the Pavement
	    this.pavRect.attr('width', pavPlusPostWidth * s).attr('height', sizes.pavHeight * s).attr('x', 0).attr('y', svgHeight - sizes.pavHeight * s);
	
	    // Update fov triangle
	    // Work out the coordinates of each of the points (in pixels)
	    // Where is sensor
	    var startX = postWidth * s;
	    var startY = svgHeight - (sizes.heightUpPost + sizes.pavHeight) * s;
	    // Find the angles between the vertical post and diagonal lines marking the edge of the field of views
	    var leftAngle = sizes.mountAngle - sizes.fovAngle / 2;
	    var rightAngle = sizes.mountAngle + sizes.fovAngle / 2;
	    // Where does the left-hand side of the FoV intesect with the road
	    var leftX = (this.calcOpposite(sizes.heightUpPost + sizes.pavHeight, leftAngle) + postWidth) * s;
	    var leftY = svgHeight;
	    // Where does the right-hand side of the FoV intesect with the road
	    var rightX = (this.calcOpposite(sizes.heightUpPost + sizes.pavHeight, rightAngle) + postWidth) * s;
	    var rightY = svgHeight;
	
	    // the points are in the format x,y
	    this.viewTri.attr('points', ' ' + startX + ',' + startY + ',' + leftX + ',' + leftY + ',' + rightX + ',' + rightY);
	
	    // Update lane markers
	    // Calculate properties of each marker
	    var laneMarkData = [];
	    for (var i = 1; i <= sizes.numLanes; i++) {
	
	      var markHeight = 10; // (in pixels)
	      var markWidth = 5; // (in pixels)
	
	      laneMarkData.push({
	        x: pavPlusPostWidth * s + i * sizes.laneWidth * s - markWidth / 2,
	        y: svgHeight - markHeight,
	        width: markWidth,
	        height: markHeight
	      });
	    }
	
	    // Remove any existing marks first
	    this.svg.selectAll('.markRect').remove();
	
	    this.svg.selectAll('.markRect').data(laneMarkData).enter().append('rect').attr('class', 'markRect').attr('x', function (d) {
	      return d.x;
	    }).attr('y', function (d) {
	      return d.y;
	    }).attr('width', function (d) {
	      return d.width;
	    }).attr('height', function (d) {
	      return d.height;
	    });
	  };
	
	  // When you ask d3 to find the height or width it returns a value in the format '100px', the function removes the 'px' and converts it to a number
	
	
	  FieldOfViewDiagram.prototype.convertD3dimension = function convertD3dimension(str) {
	    return Number(str.replace('px', ''));
	  };
	
	  // Degrees to radians
	
	
	  FieldOfViewDiagram.prototype.toRadians = function toRadians(angle) {
	    return angle * (Math.PI / 180);
	  };
	
	  // Find the length of the opposite side of a triangle given the adjacent and the angle in degrees. This is useful for calculating the distance along the ground from the base of the post to edges of the field of view cone.
	
	
	  FieldOfViewDiagram.prototype.calcOpposite = function calcOpposite(adjLength, angleInDeg) {
	    return adjLength * Math.tan(this.toRadians(angleInDeg));
	  };
	
	  FieldOfViewDiagram.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('svg', { ref: function ref(node) {
	          return _this3.node = node;
	        }, className: 'fov-diagram' })
	    );
	  };
	
	  return FieldOfViewDiagram;
	}(_react2.default.Component);
	
	exports.default = FieldOfViewDiagram;
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FieldOfViewDiagram = __webpack_require__(200);
	
	var _FieldOfViewDiagram2 = _interopRequireDefault(_FieldOfViewDiagram);
	
	var _reactstrap = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldOfViewVisualiser = function (_React$Component) {
	  _inherits(FieldOfViewVisualiser, _React$Component);
	
	  function FieldOfViewVisualiser(props) {
	    _classCallCheck(this, FieldOfViewVisualiser);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      heightUpPost: 3,
	      laneWidth: 3,
	      numLanes: 2,
	      pavWidth: 1,
	      pavHeight: 0.12,
	      mountAngle: 38,
	      fovAngle: 10
	    };
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  FieldOfViewVisualiser.prototype.handleInputChange = function handleInputChange(event) {
	    var _setState;
	
	    var target = event.target;
	    var value = this.isNumeric(target.value) ? Number(target.value) : target.value;
	    var name = target.name;
	
	    this.setState((_setState = {}, _setState[name] = value, _setState));
	  };
	
	  FieldOfViewVisualiser.prototype.handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	  };
	
	  FieldOfViewVisualiser.prototype.isNumeric = function isNumeric(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	  };
	
	  FieldOfViewVisualiser.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_FieldOfViewDiagram2.default, {
	        heightUpPost: this.state.heightUpPost,
	        laneWidth: this.state.laneWidth,
	        numLanes: this.state.numLanes,
	        pavWidth: this.state.pavWidth,
	        pavHeight: this.state.pavHeight,
	        mountAngle: this.state.mountAngle,
	        fovAngle: this.state.fovAngle
	      }),
	      _react2.default.createElement(
	        _reactstrap.Form,
	        null,
	        _react2.default.createElement(
	          _reactstrap.FormGroup,
	          { row: true },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: 12, sm: 6 },
	            _react2.default.createElement(
	              _reactstrap.Label,
	              { 'for': 'fovAngle' },
	              'Field of View Angle (\xB0; full arc)'
	            ),
	            _react2.default.createElement(_reactstrap.Input, {
	              type: 'number',
	              name: 'fovAngle',
	              id: 'fovAngle',
	              placeholder: 'in degrees e.g. 16',
	              value: this.state.fovAngle,
	              onChange: this.handleInputChange
	            })
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: 12, sm: 6 },
	            _react2.default.createElement(
	              _reactstrap.Label,
	              { 'for': 'mountAngle' },
	              'Mount Angle (\xB0)'
	            ),
	            _react2.default.createElement(_reactstrap.Input, {
	              type: 'number',
	              name: 'mountAngle',
	              id: 'mountAngle',
	              placeholder: 'in degrees e.g. 38',
	              value: this.state.mountAngle,
	              onChange: this.handleInputChange
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.FormGroup,
	          { row: true },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: 12, sm: 6 },
	            _react2.default.createElement(
	              _reactstrap.Label,
	              { 'for': 'heightUpPost' },
	              'Sensor Height up Post (m)'
	            ),
	            _react2.default.createElement(_reactstrap.Input, {
	              type: 'number',
	              name: 'heightUpPost',
	              id: 'heightUpPost',
	              placeholder: 'in metres e.g. 3',
	              value: this.state.heightUpPost,
	              onChange: this.handleInputChange
	            })
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: 12, sm: 6 },
	            _react2.default.createElement(
	              _reactstrap.Label,
	              { 'for': 'laneWidth' },
	              'Lane Width (m)'
	            ),
	            _react2.default.createElement(_reactstrap.Input, {
	              type: 'number',
	              name: 'laneWidth',
	              id: 'laneWidth',
	              placeholder: 'in metres',
	              value: this.state.laneWidth,
	              onChange: this.handleInputChange
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.FormGroup,
	          { row: true },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: 12, sm: 6 },
	            _react2.default.createElement(
	              _reactstrap.Label,
	              { 'for': 'numLanes' },
	              'Number of Lanes'
	            ),
	            _react2.default.createElement(_reactstrap.Input, {
	              type: 'number',
	              name: 'numLanes',
	              id: 'numLanes',
	              placeholder: 'e.g. 2 for dual carriageway',
	              value: this.state.numLanes,
	              onChange: this.handleInputChange
	            })
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: 12, sm: 6 },
	            _react2.default.createElement(
	              _reactstrap.Label,
	              { 'for': 'pavWidth' },
	              'Pavement/Verge Width (m)'
	            ),
	            _react2.default.createElement(_reactstrap.Input, {
	              type: 'number',
	              name: 'pavWidth',
	              id: 'pavWidth',
	              placeholder: 'in metres from post to road',
	              value: this.state.pavWidth,
	              onChange: this.handleInputChange
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.FormGroup,
	          { row: true },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: 12, sm: 6 },
	            _react2.default.createElement(
	              _reactstrap.Label,
	              { 'for': 'pavHeight' },
	              'Pavement/Verge Height (m)'
	            ),
	            _react2.default.createElement(_reactstrap.Input, {
	              type: 'number',
	              name: 'pavHeight',
	              id: 'pavHeight',
	              placeholder: 'in metres, e.g. 0.12',
	              value: this.state.pavHeight,
	              onChange: this.handleInputChange
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return FieldOfViewVisualiser;
	}(_react2.default.Component);
	
	exports.default = FieldOfViewVisualiser;
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WinterJumbo = function (_React$Component) {
	  _inherits(WinterJumbo, _React$Component);
	
	  function WinterJumbo() {
	    _classCallCheck(this, WinterJumbo);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WinterJumbo.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#00BFF3',
	          padding: '15px',
	          textAlign: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'h1',
	        {
	          style: {
	            marginBottom: '0'
	          }
	        },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'p',
	        {
	          style: {
	            marginBottom: '0'
	          }
	        },
	        this.props.subtitle
	      )
	    );
	  };
	
	  return WinterJumbo;
	}(_react2.default.Component);
	
	// Prop types are a feature for runtime validation of props during development.
	
	
	WinterJumbo.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = WinterJumbo;
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WinterJumbo = __webpack_require__(41);
	
	var _WinterJumbo2 = _interopRequireDefault(_WinterJumbo);
	
	var _FieldOfViewVisualiser = __webpack_require__(201);
	
	var _FieldOfViewVisualiser2 = _interopRequireDefault(_FieldOfViewVisualiser);
	
	var _reactstrap = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldOfView = function FieldOfView() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_WinterJumbo2.default, {
	      title: 'Field of View Visualiser'
	    }),
	    _react2.default.createElement(
	      _reactstrap.Container,
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: 'text-justify mt-3' },
	        'Every infrared sensor has a specific ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'Field of View'
	        ),
	        '. It is the average temperature of objects within this field of view that the sensor records (assuming the objects don\'t reflect a lot of infrared radiation).'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'text-justify' },
	        'Infrared sensors with a very large field of view measure almost every surface in front of them, whereas sensors with a narrow field of view, such as the Wintersense sensor, are more focused on objects directly ahead.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'text-justify' },
	        'The tool below assumes the Wintersense sensor is mounted to a post (e.g. lighting column) by the side of the road. It allows you to adjust various parameters to show how the field of view, and consequently the section of road surface being measured, changes.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'text-justify' },
	        'A typical installation is shown to begin with. The sensor is mounted 3 metres up a column that is 1 metre back from lane 1. The field of view angle of 10\xB0 is typical for the Wintersense sensor. Only the temperature of surfaces within the field of view (the light blue triangle) effect the temperature reading. In this scenario then the sensor measures the center of lane 1. Note that in reality the temperature of surfaces in the middle of the field of view have a greater weighting on the overall temperature than surfaces at the edge.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'text-justify' },
	        'Try adjusting the values below to match your potential installation site. For example, try increasing the ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'Sensor Height up Post'
	        ),
	        ' to 5 metres and decreasing the ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'Mount Angle'
	        ),
	        ' to 25\xB0. Notice how a greater proportion of lane 1 is now being measured.'
	      ),
	      _react2.default.createElement(_FieldOfViewVisualiser2.default, null)
	    ),
	    _react2.default.createElement('br', null)
	  );
	};
	
	exports.default = FieldOfView;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-field-of-view-js-432f07bed675212a01e8.js